import { Box } from "@mui/material"

import Header from "./Header"
import Projects from "./Projects"
import Skills from './Skills'
import Contact from './Contact'


const Portfolio = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <Header />
      <Projects />
      <Skills />
      <Contact />
    </Box>
  )
}

export default Portfolio